import { render, staticRenderFns } from "./TheHeaderDropdownBadge.vue?vue&type=template&id=13e214b2&scoped=true"
import script from "./TheHeaderDropdownBadge.vue?vue&type=script&lang=js"
export * from "./TheHeaderDropdownBadge.vue?vue&type=script&lang=js"
import style0 from "./TheHeaderDropdownBadge.vue?vue&type=style&index=0&id=13e214b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e214b2",
  null
  
)

export default component.exports